import { Box, Button, Grid } from "@mui/material"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../../../core/context/ToolContext"
import { PersonalizeToolTip } from "../../../../../../core/styling/Tooltip";
import { CustomPropTemplate } from "../modal/Index";
import { avatarstylesy } from "../../../../../../core/styling/global";
import { rqx } from "../../../../../../core/request/API";
import { env } from "../../../../../../core/Env";
import { SnakeLoader } from "../../../../../../core/loader/SnakeLoader";
import IMGCover1 from "../../../../../../assets/images/core/property-template.png";




export const TemplatesList = () => {
    const { salespage_state } = useContext(ToolContext)
    const { templates, templateData, templateLoader, cmtznLoader } = salespage_state;
    useEffect(() => {
        const __init = async () => {
            templateLoader.set(true)
            const t = await rqx.get(`<<tool>>/${env()}/realProperty/read`)
            templateData.set(t)
            templateLoader.set(false)
        }
        __init()
        // eslint-disable-next-line
    }, [])

    const showPropModal = (id, section_id) => {
        templates.set({...templates.data, preview: true, id: id, section_id: section_id })
    }
    return (
        <Box mt={2}>
            {
                templateLoader.data ?
                    <Box pt={15} display="flex" justifyContent="center" alignItems="center" flexDirection="column" my={5} >
                        <SnakeLoader size="14px" bg="#009F4D" distance="0.3rem" />
                    </Box>
                :
                    <Grid container spacing={2}>
                        {templateData.data.map((v,k) => (
                            <Grid item xs={2} key={k}>
                                <PersonalizeToolTip title="Click to use this template" placement="right" arrow>
                                    <Box onClick={() => showPropModal(v.id, v.section_id)} component={Button} color="#333" bgcolor="#F3F5F4" alignItems="flex-start" width="100%" display="flex" flexDirection="column" height={245} border="1px solid #000" borderRadius={2} p={2} sx={{ ':hover': { bgcolor: '#fff' } }}

                                    >
                                        <Box bgcolor="#F3F5F4" borderRadius={2} width="100%">
                                            <Box sx={avatarstylesy(IMGCover1, '100%', 165, '10px 10px 0 0')} />
                                        </Box>
                                        <Box mt="auto" fontSize={14} fontWeight={600} textAlign="center" width="100%">{v.name}</Box>
                                    </Box>
                                </PersonalizeToolTip>
                            </Grid>
                        ))}
                        <CustomPropTemplate templates={templates} cmtznLoader={cmtznLoader} />
                    </Grid>
            }
        </Box>
    )
}




